import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { FetchError } from '../../../common/api/api';
import { WorkflowVersion } from '../Workflow.interface';
import { useWorkflowStatuses } from '../Workflow.hooks';

export interface WorkflowStatusSelectorProps {
  value?: string[];
  label?: string;
  options?: string[];
  workflowVersion?: WorkflowVersion;
  error?: FetchError;
  isLoading?: boolean;
  className?: string;
  textFieldProps?: Omit<TextFieldProps, 'variant'>;
  onChange?: (value?: string[]) => void;
}

const WorkflowStatusSelector: React.FC<WorkflowStatusSelectorProps> = (
  props: WorkflowStatusSelectorProps
) => {
  const {
    options: optionsProp,
    workflowVersion,
    value = [],
    error,
    isLoading,
    label = 'Filter by Status',
    className,
    textFieldProps,
    onChange
  } = props;
  const options: string[] = useWorkflowStatuses(workflowVersion);

  return (
    <Autocomplete
      multiple
      loading={isLoading}
      options={optionsProp || options}
      value={value || null}
      className={className}
      onChange={(_event: React.ChangeEvent<{}>, value: string[]) => {
        onChange?.(value);
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          variant='outlined'
          label={isLoading ? 'Loading...' : error ? 'An error occurred' : label}
          {...textFieldProps}
        />
      )}
    />
  );
};

export default WorkflowStatusSelector;
